import { render, staticRenderFns } from "./SpinnerButton.vue?vue&type=template&id=35ff6fe9&"
import script from "./SpinnerButton.vue?vue&type=script&lang=js&"
export * from "./SpinnerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports